import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalInfo } from 'src/app/models/modal-info';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InstrumentsService } from 'src/app/services/backoffice/instruments/instruments.service';
import { AuthService } from 'src/app/services/backoffice/auth/auth.service';

@Component({
  selector: 'app-model',
  templateUrl: './model.component.html',
  styleUrls: ['./model.component.scss']
})

export class ModelComponent implements OnInit, OnDestroy {

  models = [];
  mineForm: FormGroup;

  headElements = ['N°', 'nombre', 'Marca', 'Herramientas'];
  headTable = ['nombre', 'marca', 'tools'];
  colspanLarge: number = 4;

  modalInfo: ModalInfo = new ModalInfo();
  stateModalAlert: boolean = false;
  stateModalTable: boolean = false;

  stateModalType: boolean = false;
  typeObject: string = 'new';
  dataObject: any;

  objectsSubscription: Subscription;
  objectSelected: any;

  constructor( private instrumentsService: InstrumentsService, private router: Router, private formBuilder: FormBuilder, public authService: AuthService ) { }

  ngOnInit(): void {

    this.getModels();
  }

  ngOnDestroy(){

    this.objectsSubscription?.unsubscribe();
 }


  onreponsDeleteObjectTable($event){
    console.log('COMPANY1: '+$event.uid);
    this.objectSelected = $event;
    this.messageAlert(true, 'warning', 'Esta seguro de eliminar '+$event.nombre);    
  }

  onreponseUpdateObjectTable($event){
    console.log('UPDATE: ');
    this.typeObject = 'edit';
    this.stateModalType = true;
    this.dataObject = $event;
  }

  onResponseAlert(event){
    this.stateModalAlert = false;
  }

  onReponseDeleteObjectModal($event){

    this.deleteObject(this.objectSelected.id);
  }

  onReponseStateModalFormMine(event){
    this.stateModalType = event;
  }
  
  addObject(){
    this.typeObject = 'new';
    this.stateModalType = true;
  }
  
  onResponseRefresh(){
    this.getModels();
  }
  
  getModels(){
  
    this.objectsSubscription = this.instrumentsService.getModels( ).subscribe({
      next: (resp) => { 
         this.models = resp;
         this.stateModalTable = true;  
         console.log('Response: ' + resp); 
        },
      error: (err) => { console.log('Received an error: ' + err.message)},
      complete: () => { 
        console.log('Completed'); 
      }
    });
  }

  deleteObject(id: string){

    this.instrumentsService.deleteModel(id).subscribe({
      next: (resp) => { 
         //this.getMines();  
         this.models = this.models.filter(objeto => objeto.id !== this.objectSelected.id);
         this.messageAlert(true, 'success', 'El modelo fue eliminada satisfactoriamente'); 
         console.log('Response: ' + resp); 
        },
      error: (err) => { console.log('Received an error: ' + err.message)},
      complete: () => { 
        console.log('Completed'); 
      }
    });
  }
  
  messageAlert(state: boolean, type: string, messageModal: string) {
    this.stateModalAlert = state;
    this.modalInfo.messageModal = messageModal;
    this.modalInfo.type = type;
  }
}

